var _defs, _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCofounderHubLogoLightNoBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 457.1011 229.8",
    width: 457.1011,
    height: 229.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\n    .st0 { fill: #F7931E; }\n    .st1 { fill: #FFFFFF; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "translate(-21.498881,-44.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 382.3,252.6 h -30.1 v 20.8 h -6.6 v -44.3 h 6.6 v 17.7 h 30.1 v -17.7 h 6.6 v 44.3 h -6.6 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 393.6,229.2 h 6.6 v 28.3 c 0,8 5.3,11.3 13.5,11.3 8.1,0 13.5,-3.3 13.5,-11.3 v -28.3 h 6.6 v 27.5 c 0,11.8 -6.6,17.9 -20,17.9 -13.4,0 -20,-6 -20,-17.9 z",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 438.4,229.2 H 463 c 9.4,0 13.6,4.2 13.6,11.1 0,5.4 -2.9,8.1 -6.4,9.4 v 0.1 c 5.1,1.2 8.4,4.5 8.4,10.9 0,6.3 -4.4,12.8 -14,12.8 h -26.2 z m 24.4,38.6 c 7.3,0 9.2,-3.7 9.2,-7.5 0,-3.5 -2,-7.1 -8.7,-7.1 h -18.4 v 14.6 z m 0.1,-20.3 c 4.8,0 7.2,-2.7 7.2,-6.2 0,-4 -2.2,-6.4 -7.6,-6.4 H 445 v 12.6 z",
    id: "path3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "translate(-21.498881,-44.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 48.5,71.9 V 70.7 C 47.9,64 47.9,64 47.2,62.6 c -1.3,-1.7 -3.5,-2.9 -5.7,-2.9 -5.7,0.1 -7.4,3 -7.3,12.4 l 1.3,120 c 0.1,8.1 2.1,11.1 7.3,11 5.4,-0.1 7.1,-3 7,-11.9 l -0.4,-36.3 12.3,-0.1 0.4,35.3 c 0.1,8.2 -0.8,13.6 -3.3,16.8 -3.4,5 -9.5,8 -16,8.1 -7.7,0.1 -14.6,-4 -17.6,-10.4 -1.5,-3.2 -2.3,-7.9 -2.4,-15.3 L 21.5,72.7 C 21.4,56.6 28,48.4 41.3,48.3 54.4,48.2 60.6,55.8 60.8,72.5 l 0.4,34.6 -12.3,0.1 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 111,189.6 c 0.2,17.5 -5.2,24.5 -19,24.7 C 79.4,214.4 73.9,208.1 73.7,193 L 73,123.3 c -0.2,-15.1 5,-20.8 18.6,-20.9 13.1,-0.1 18.6,5.7 18.7,19.6 z m -25.4,4.7 c 0.1,6.7 2.1,9.4 6.8,9.3 4.9,-0.1 6.4,-2.5 6.3,-9.7 L 98,123.3 c -0.1,-8.1 -1.3,-10.4 -6.5,-10.3 -4.9,0.1 -6.6,2.5 -6.6,9.9 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 147.9,113.8 -8.2,0.1 1,98.8 -12.6,0.1 -1,-99 -7.4,0.1 -0.1,-10.6 7.4,-0.1 V 67.9 c -0.1,-13.8 4,-20 13.6,-20.2 3,0 5.7,0.7 7.2,2.1 l 0.1,9.9 c -1.2,-0.7 -3,-1.2 -4.7,-1.2 -3.2,0 -3.9,1.3 -3.9,6 l 0.4,38.8 8.2,-0.1 z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 196.4,188.7 c 0.2,17.5 -5.2,24.5 -19,24.7 -12.6,0.1 -18.1,-6.2 -18.3,-21.3 l -0.7,-69.6 c -0.2,-15.1 5,-20.8 18.6,-20.9 13.1,-0.1 18.6,5.7 18.7,19.6 z m -25.4,4.7 c 0.1,6.7 2.1,9.4 6.8,9.3 4.9,-0.1 6.4,-2.5 6.3,-9.7 l -0.7,-70.6 c -0.1,-8.1 -1.3,-10.4 -6.5,-10.3 -4.9,0.1 -6.6,2.5 -6.6,9.9 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 232,211.8 -0.1,-4.9 c -3.9,4 -6.9,5.3 -11.1,5.3 -7.9,0.1 -11.9,-5.6 -12,-16.9 l -1,-92.6 11.6,-0.1 0.9,88.7 c 0.1,8.4 1.1,11.1 4.8,11.1 2.7,0 5.2,-1.8 6.4,-4.5 l -1,-95.3 11.6,-0.1 1.2,109.4 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 265.9,102 v 4.2 c 3.9,-3.7 6.4,-5 10.6,-5.1 8.4,-0.1 12.4,5.3 12.5,17.2 l 1,92.9 -11.6,0.1 -0.9,-89.2 c -0.1,-8.6 -1.1,-11.1 -5.1,-11.1 -3.2,0 -5.2,2.3 -6.1,6.2 l 1,94.1 -11.6,0.1 -1.2,-109.4 z",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 337.2,210.7 -10.1,0.1 -1,-4.2 c -3.4,3.2 -6.6,4.8 -10.6,4.8 -9.1,0.1 -13.2,-6 -13.3,-20.9 l -0.7,-68.9 c -0.2,-14.6 3.5,-20.5 12.9,-20.6 3.7,0 5.9,0.9 9.7,3.6 l -0.6,-58 12.1,-0.1 z m -12.9,-95.3 c -0.2,-0.2 -0.5,-0.5 -0.7,-0.5 -1,-1 -1.7,-1.7 -2.7,-2.4 -0.5,-0.5 -1.5,-0.7 -2.7,-0.7 -4,0 -5.2,2.8 -5.1,11.4 l 0.7,68.2 c 0.1,7.7 1.3,10.1 5.5,10.1 2.2,0 2.7,-0.3 5.9,-3.8 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 361.7,190.1 c 0.1,8.4 1.3,10.6 6.3,10.6 4.4,0 5.4,-1.8 5.3,-10.2 l -0.2,-22.7 11.9,-0.1 0.3,24.2 c 0.1,12.8 -5.5,19.3 -17.3,19.4 -12.1,0.1 -18.3,-6.2 -18.5,-19.6 l -0.8,-72.6 c -0.1,-13.8 5.7,-20.6 18.6,-20.7 6.9,-0.1 11.4,1.9 14.6,5.8 0.8,1 2.6,8.4 2.6,9.9 l 0.5,43.2 -23.5,0.2 z m 10.6,-44 v -27.7 c -0.1,-6.9 -1.1,-8.4 -5.5,-8.3 -4.4,0 -6.1,3 -6.1,10.4 l 0.5,25.7 z",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 407.4,100.5 0.3,6.4 c 3.4,-4.5 6.4,-6.2 10.3,-6.3 2.2,0 3.2,0.2 4.7,1.2 l 0.1,10.6 c -1.5,-0.5 -2.5,-0.7 -4,-0.7 -6.2,0.1 -10.1,4.1 -10,10.2 l 0.9,87.9 -12.1,0.1 -1.2,-109.4 z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 440.9,44.8 0.3,27.2 -10.4,0.1 -0.3,-27.2 z",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 465.4,117.7 c -0.1,-6.7 -1.6,-9.1 -5.8,-9.1 -2.2,0 -4.2,0.8 -5.2,2.3 -1,1.5 -1.7,4.7 -1.2,5.9 0.2,0.2 0.3,0.5 0.3,0.7 l 0.2,18.3 c 0,0 0,0.5 -0.2,1.5 -0.4,4.5 1.1,6.4 6,9.3 l 8.2,4.6 c 7.2,4.1 9,7.3 9.1,15.2 l 0.3,23.7 c 0.1,13.6 -5.5,20.1 -17.3,20.2 -11.4,0.1 -16.9,-6.2 -17,-19.6 l -0.2,-20 11.6,-0.1 0.2,20.5 c 0.1,6.7 1.3,8.6 5.8,8.6 4.7,0 5.4,-1.5 5.3,-9.4 l -0.2,-20 c -0.1,-6.7 -0.8,-8.1 -5.5,-10.8 l -7.5,-4.1 c -8.5,-5.3 -10.5,-8.5 -10.3,-17.2 l -0.2,-17.5 c -0.1,-8.2 0.6,-11.9 2.6,-14.8 3.2,-4.7 8.6,-7.3 15.2,-7.3 11.6,-0.1 17.6,6.2 17.7,18.8 l 0.2,19.5 -11.9,0.1 z",
    id: "path14"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g17",
    transform: "translate(-21.498881,-44.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 83.2,55.5 H 79.4 V 92.4 H 75.8 V 55.5 h -3.5 v -2.9 h 10.9 z",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 97.8,92.3 H 94.1 V 73.5 H 90 V 92.3 H 86.4 V 52.6 H 90 v 17.8 h 4.1 V 52.6 h 3.7 z",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 110.6,52.6 v 3 h -4.7 v 14.9 h 4.8 v 2.8 h -4.8 v 16.1 h 4.8 v 2.9 h -8.6 V 52.6 Z",
    id: "path17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCofounderHubLogoLightNoBorder);
export default __webpack_public_path__ + "static/media/logo_cofounder_hub_logo_light-no-border.dd53ce848954c4a84f4a3afce177db4c.svg";
export { ForwardRef as ReactComponent };